import { Fragment, useEffect, useMemo, useState } from "react";
import { TechnicalDetails } from "./techinalDetails";
import { FeatureContainer } from "./featureContainer";
import { SpecificationContainer } from "./specificationContainer";
import { descriptionHasValue } from "../scripts";
import { VideoContainer } from "./videoContainer";
import { ApplicationsContainer } from "./applicationsContainer";
import { NotesContainer } from "./notesContainer";
import { ViewAllProductButton } from "../family/rightSideUtilityButton";

const hasVisibleText = (html) =>
  !!html &&
  String(html)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim() !== "";

const hasFeatureItems = (html) => {
  if (!html) return false;
  const doc = new DOMParser().parseFromString(html, "text/html");
  return Array.from(doc.querySelectorAll("li")).some((li) => li.textContent.trim() !== "");
};

export const hasAnyDetails = (params) =>
  !!params &&
  (hasFeatureItems(params.feature) ||
    !!params.videoSrc ||
    hasVisibleText(params.familyDesc) ||
    hasVisibleText(params.specification) ||
    hasVisibleText(params.applications) ||
    hasVisibleText(params.notes));

export const DescriptionContainer = ({ params }) => {
  const [familyData, setFamilyData] = useState(null);
  const [familyDesc, setFamilyDesc] = useState(null);
  const [notes, setNotes] = useState(null);
  const [applications, setApplications] = useState(null);
  useEffect(() => {
    if (params && descriptionHasValue(params)) {
      setFamilyData(params);
      let desc = params.familyDesc.replaceAll("\r\n", "<br />");
      setFamilyDesc(desc);
      var _notes = params.notes ? params.notes : null;
      if (String(_notes).toLowerCase().includes("note:")) {
        _notes = _notes.replace("Note:", "").replace("note:", "").replace("NOTE:", "");
      }
      if (String(_notes).toLowerCase().includes("<bol>")) {
        _notes = _notes.replace("<bol>", "<strong>").replace("</bol>", "</strong>");
      }
      setNotes(_notes);
      setApplications(params.applications);
    } else {
      setFamilyData(null);
      setFamilyDesc(null);
      setNotes(null);
      setApplications(null);
    }
  }, [params]);

  const showFamilyViewProducts = useMemo(
    () => !!params && params.isFamily !== false && !hasAnyDetails(params),
    [params],
  );

  return (
    <Fragment>
      {showFamilyViewProducts && (
        <div className="proSection-title custom-border pt-1 mb-0">
          <ViewAllProductButton />
        </div>
      )}
      {familyData && (
        <div className="product-detailed-feature mt-4" id="section-descriptions">
          <div className="prosection-features">
            <FeatureContainer htmlString={familyData.feature} />

            {familyData.videoSrc && <VideoContainer url={familyData.videoSrc} />}
            {familyDesc && (
              <div className={"productDescription mt-4"}>
                <div className="proSection-title featuresListing-right">
                  <h4>Details</h4>
                </div>
                <div className="prosection-description">
                  <p className="productPage-content" dangerouslySetInnerHTML={{ __html: familyDesc }} />
                </div>
              </div>
            )}
            <SpecificationContainer params={familyData} />
            {applications && (
              <div className="prosection-applications mt-4">
                <div className="proSection-title featuresListing-right">
                  <h4>Applications</h4>
                </div>
                <div className="prosection-description">
                  <p className="productPage-content" dangerouslySetInnerHTML={{ __html: applications }} />
                </div>
              </div>
            )}
            {notes && (
              <div className="prosection-notes mt-4">
                <div className="proSection-title featuresListing-right">
                  <h4>Notes</h4>
                </div>
                <div className="prosection-description">
                  <p className="productPage-content" dangerouslySetInnerHTML={{ __html: notes }}></p>
                </div>
              </div>
            )}
            {familyData.isFamily == false && <TechnicalDetails params={familyData} />}
          </div>
        </div>
      )}
    </Fragment>
  );
};
